import { render, staticRenderFns } from "./MarketDescriptionCard.vue?vue&type=template&id=0e1d164c"
import script from "./MarketDescriptionCard.vue?vue&type=script&lang=js"
export * from "./MarketDescriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports